import type { BillingInterval, BillingPlan, BillingPlanList, BillingTier } from "@/lib/api/billing";

/**
 * The plans as billing lists them, and who is looking at them. Pure.
 */

/** Who is looking: a person on a plan, or a visitor signed out. */
export type Viewer = { kind: "member"; tier: BillingTier } | { kind: "visitor" };

/** The plans, lowest first. */
export const TIER_ORDER: readonly BillingTier[] = ["free", "pro", "max"];

/** The plan billing lists for a tier, if it lists one. */
export function planOf(
    plans: BillingPlanList | undefined,
    tier: BillingTier,
): BillingPlan | undefined {
    return plans?.plans.find((plan) => plan.tier === tier);
}

/** A plan's price for a period, when it is sold that way and costs money. */
export function priceOf(plan: BillingPlan | undefined, interval: BillingInterval) {
    return plan?.prices.find((price) => price.interval === interval && price.unit_amount > 0);
}
